import { Vector3 } from "flavr-math";
import { localPlayerContainer } from "../../localplayer/LocalPlayerContainer";
import { AbstractTrackedObject } from "./AbstractTrackedObject";
export class TrackedCamera extends AbstractTrackedObject {
    constructor(name, referencedObjectUid, threshold = 0.45) {
        super(name, threshold, referencedObjectUid);
        this.prevPosition = new Vector3();
        this.prevTimestamp = 0;
    }
    getPosition() {
        return localPlayerContainer.cameraWorldPosition;
    }
    getOrientation() {
        return localPlayerContainer.cameraWorldOrientation;
    }
    getLinearVelocity() {
        const pos = this.getPosition();
        const timestamp = Date.now();
        if (pos === undefined || pos === null)
            return undefined;
        try {
            if (this.prevPosition !== undefined && this.prevTimestamp !== undefined) {
                const dtMs = timestamp - this.prevTimestamp;
                if (dtMs <= 0)
                    return undefined;
                const dtSec = dtMs / 1000;
                return pos.clone().sub(this.prevPosition).divideScalar(dtSec);
            }
        }
        finally {
            this.prevPosition = pos.clone();
            this.prevTimestamp = timestamp;
        }
    }
}
